import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../types/AuthActionType";
import {IAuthModalVariant} from "./auth_modal_slice";
import {IRegistrationFlowPreferences} from "./registration_flow_slice";

export enum RegistrationFlowStepVariantB {
    REGISTRATION = "REGISTRATION",
    PREFERENCES = "PREFERENCES",
    PHONE_VERIFICATION = "PHONE_VERIFICATION",
    UPDATED_PREFERENCES = "UPDATED_PREFERENCES"
}

export type RegistrationMethod = "email" | "social";
export type SocialMediaType = "google" | "facebook";

interface IRegistrationFlowState {
    isActive: boolean;
    registrationMethod: RegistrationMethod;
    currentStep: RegistrationFlowStepVariantB;
    userNeedsProfileCompletion: boolean;
    socialMediaType?: SocialMediaType;
    userSource?: UserSource;
    gtmSourceSection?: string;
    preferences: IRegistrationFlowPreferences | null;
    modalVariant: IAuthModalVariant;
    lastAuthAction: AuthActionType | null;
    propertyId?: number;
    offerId?: number;
}

const initialState: IRegistrationFlowState = {
    isActive: false,
    registrationMethod: "email",
    currentStep: RegistrationFlowStepVariantB.REGISTRATION,
    userNeedsProfileCompletion: false,
    userSource: undefined,
    gtmSourceSection: undefined,
    preferences: null,
    modalVariant: "hidden_prices_variant_b",
    propertyId: undefined,
    offerId: undefined,
    lastAuthAction: null
};

export interface IStartRegistrationFlowPayload {
    userNeedsProfileCompletion: boolean;
    registrationMethod?: RegistrationMethod;
    socialMediaType?: SocialMediaType;
    userSource?: UserSource;
    gtmSourceSection?: string;
    modalVariant?: IAuthModalVariant;
    propertyId?: number;
    offerId?: number;
}

export const registrationFlowVariantBSlice = createSlice({
    name: "registrationFlowVariantB",
    initialState,
    reducers: {
        startRegistrationFlowVariantB: (state, action: PayloadAction<IStartRegistrationFlowPayload>) => {
            state.isActive = true;
            state.userNeedsProfileCompletion = action.payload.userNeedsProfileCompletion;
            state.socialMediaType = action.payload.socialMediaType;
            state.userSource = action.payload.userSource;
            state.gtmSourceSection = action.payload.gtmSourceSection;
            state.propertyId = action.payload.propertyId;
            state.offerId = action.payload.offerId;

            // Determine starting step based on whether profile completion is needed
            if (action.payload.userNeedsProfileCompletion) {
                state.currentStep = RegistrationFlowStepVariantB.PHONE_VERIFICATION;
            } else {
                state.currentStep = RegistrationFlowStepVariantB.REGISTRATION;
            }
        },
        nextStepVariantB: (state, action: PayloadAction<{userNeedsProfileCompletion?: boolean}>) => {
            switch (state.currentStep) {
                case RegistrationFlowStepVariantB.REGISTRATION:
                    if (action.payload.userNeedsProfileCompletion) {
                        state.userNeedsProfileCompletion = true;

                        state.currentStep = RegistrationFlowStepVariantB.PHONE_VERIFICATION;
                    } else {
                        state.currentStep = RegistrationFlowStepVariantB.PREFERENCES;
                    }
                    break;
                case RegistrationFlowStepVariantB.PHONE_VERIFICATION:
                    state.currentStep = RegistrationFlowStepVariantB.PREFERENCES;
                    break;
                case RegistrationFlowStepVariantB.PREFERENCES:
                    state.currentStep = RegistrationFlowStepVariantB.UPDATED_PREFERENCES;
                    break;
                default:
                    state.isActive = false;
            }
        },
        savePreferencesVariantB: (state, action: PayloadAction<IRegistrationFlowPreferences>) => {
            state.preferences = action.payload;
        },
        closeFlowVariantB: () => {
            return initialState;
        },
        setLastAuthActionVariantB: (state, action: PayloadAction<{authAction: AuthActionType}>) => {
            const {authAction} = action.payload;
            state.lastAuthAction = authAction;
        },
        setRegistrationMethodVariantB: (state, action: PayloadAction<{method: RegistrationMethod}>) => {
            state.registrationMethod = action.payload.method;
        }
    }
});

export const {
    startRegistrationFlowVariantB,
    nextStepVariantB,
    savePreferencesVariantB,
    closeFlowVariantB,
    setLastAuthActionVariantB,
    setRegistrationMethodVariantB
} = registrationFlowVariantBSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../types/AuthActionType";
import {IAuthModalVariant} from "./auth_modal_slice";
import {IRegistrationFlowPreferences} from "./registration_flow_slice";

export enum RegistrationFlowStepVariantB {
    REGISTRATION = "REGISTRATION",
    PREFERENCES = "PREFERENCES",
    PHONE_VERIFICATION = "PHONE_VERIFICATION",
    UPDATED_PREFERENCES = "UPDATED_PREFERENCES"
}

export type RegistrationMethod = "email" | "social";
export type SocialMediaType = "google" | "facebook";

interface IRegistrationFlowState {
    isActive: boolean;
    registrationMethod: RegistrationMethod;
    currentStep: RegistrationFlowStepVariantB;
    userNeedsProfileCompletion: boolean;
    socialMediaType?: SocialMediaType;
    userSource?: UserSource;
    gtmSourceSection?: string;
    preferences: IRegistrationFlowPreferences | null;
    modalVariant: IAuthModalVariant;
    lastAuthAction: AuthActionType | null;
    propertyId?: number;
    offerId?: number;
}

const initialState: IRegistrationFlowState = {
    isActive: false,
    registrationMethod: "email",
    currentStep: RegistrationFlowStepVariantB.REGISTRATION,
    userNeedsProfileCompletion: false,
    userSource: undefined,
    gtmSourceSection: undefined,
    preferences: null,
    modalVariant: "hidden_prices_variant_b",
    propertyId: undefined,
    offerId: undefined,
    lastAuthAction: null
};

export interface IStartRegistrationFlowPayload {
    userNeedsProfileCompletion: boolean;
    registrationMethod?: RegistrationMethod;
    socialMediaType?: SocialMediaType;
    userSource?: UserSource;
    gtmSourceSection?: string;
    modalVariant?: IAuthModalVariant;
    propertyId?: number;
    offerId?: number;
}

export const registrationFlowVariantBSlice = createSlice({
    name: "registrationFlowVariantB",
    initialState,
    reducers: {
        startRegistrationFlowVariantB: (state, action: PayloadAction<IStartRegistrationFlowPayload>) => {
            state.isActive = true;
            state.userNeedsProfileCompletion = action.payload.userNeedsProfileCompletion;
            state.socialMediaType = action.payload.socialMediaType;
            state.userSource = action.payload.userSource;
            state.gtmSourceSection = action.payload.gtmSourceSection;
            state.propertyId = action.payload.propertyId;
            state.offerId = action.payload.offerId;

            // Determine starting step based on whether profile completion is needed
            if (action.payload.userNeedsProfileCompletion) {
                state.currentStep = RegistrationFlowStepVariantB.PHONE_VERIFICATION;
            } else {
                state.currentStep = RegistrationFlowStepVariantB.REGISTRATION;
            }
        },
        nextStepVariantB: (state, action: PayloadAction<{userNeedsProfileCompletion?: boolean}>) => {
            switch (state.currentStep) {
                case RegistrationFlowStepVariantB.REGISTRATION:
                    if (action.payload.userNeedsProfileCompletion) {
                        state.userNeedsProfileCompletion = true;

                        state.currentStep = RegistrationFlowStepVariantB.PHONE_VERIFICATION;
                    } else {
                        state.currentStep = RegistrationFlowStepVariantB.PREFERENCES;
                    }
                    break;
                case RegistrationFlowStepVariantB.PHONE_VERIFICATION:
                    state.currentStep = RegistrationFlowStepVariantB.PREFERENCES;
                    break;
                case RegistrationFlowStepVariantB.PREFERENCES:
                    state.currentStep = RegistrationFlowStepVariantB.UPDATED_PREFERENCES;
                    break;
                default:
                    state.isActive = false;
            }
        },
        savePreferencesVariantB: (state, action: PayloadAction<IRegistrationFlowPreferences>) => {
            state.preferences = action.payload;
        },
        closeFlowVariantB: () => {
            return initialState;
        },
        setLastAuthActionVariantB: (state, action: PayloadAction<{authAction: AuthActionType}>) => {
            const {authAction} = action.payload;
            state.lastAuthAction = authAction;
        },
        setRegistrationMethodVariantB: (state, action: PayloadAction<{method: RegistrationMethod}>) => {
            state.registrationMethod = action.payload.method;
        }
    }
});

export const {
    startRegistrationFlowVariantB,
    nextStepVariantB,
    savePreferencesVariantB,
    closeFlowVariantB,
    setLastAuthActionVariantB,
    setRegistrationMethodVariantB
} = registrationFlowVariantBSlice.actions;
